import React, { Component } from 'react';
import { Breadcrumb,Icon,Button,Input,Card,message} from 'antd';
import { connect } from 'react-redux'
import {Link} from 'react-router-dom';
import Question from '../../../../entry_question_editor/question/question_view/view';

import API from '../../../../API/api'
import axios from 'axios'

class ErrorDuty extends Component{
    state={
        question_id:'',

        log:'',
        question:'',
        task:''
    }
    handleSearch = () => {
        const { question_id } = this.state;
        this.getErrorDuty(question_id );
        this.setState({
            searching:true
        })
    }
    handleChange = (e) => {
        this.setState({
            question_id:e.target.value
        })
    }

    getErrorDuty = (question_id) => {
        this.setState({
            log:'',
            question:'',
            task:''
        })
        axios.post(API.QUESTION_ERROR_CHECK, {question_id}).then((res)=>{
            res = res.data
            if (res.code === 0) {
                this.setState({
                    log:res.data.log,
                    question:res.data.question,
                    task:res.data.task
                })
            }else{
                message.error(res.message)
            }
        },()=>{message.error("网络错误！")})
    }
    render(){
        let {question_id,log, question, task,} = this.state

        return(
            <div>
                <Breadcrumb>
                    <Breadcrumb.Item style={{fontSize:20}}>
                        <Link to="/questionmanage">题目管理</Link>
                    </Breadcrumb.Item>
                    <Breadcrumb.Item style={{fontSize:20}}>
                        <span>解析检错</span>
                    </Breadcrumb.Item>
                </Breadcrumb>
                <div style={{marginTop:15}}>
                    <div>
                        <div style={{width:200,display:'inline-block',marginRight:20}}>
                            <Input onChange ={ this.handleChange } placeholder="输入题目ID" value={question_id} size="large" />
                        </div>
                        <Button disabled={ question_id == '' } onClick= { this.handleSearch } type="primary" size="large" icon="search">搜索</Button>
                    </div>
                    <div style={{width:'100%',marginTop:20,padding:10,boxSizing:'border-box',minHeight:300}}>
                        {
                            log&&question &&task&&
                            <Card>
                                <div style={{fontSize:14,lineHeight:2}}>
                                    {/*日志信息*/}
                                    <div>任务名：{task.name}</div>
                                    <div>
                                        <span style={{marginRight:10}}>编写解析员：{task.pic_user_name||''} </span>
                                        <span style={{marginRight:10}}>所属小组：{task.pic_group_name||''}</span>
                                        <span style={{marginRight:10}}>编写解析审核员：{task.pic_check_user_name||''}</span>

                                        <span style={{marginRight:10}}>录解析员：{task.text_user_name||''} </span>
                                        <span style={{marginRight:10}}>所属小组：{task.text_group_name||''}</span>
                                        <span style={{marginRight:10}}>录解析审核员：{task.text_check_user_name||''}</span>
                                    </div>
                                    <div>
                                        题目日志：
                                        {
                                            log.map((v,k) =>
                                                <div style={{paddingLeft:'10px',marginTop:5,borderTop:'1px solid #eee'}} key={k} >
                                                    <span style={{marginRight:20}}>用户名：{v.user_name||''}</span>
                                                    <span style={{marginRight:20}}>创建时间：{v.create_time||''}</span>
                                                    <span style={{marginRight:20}}>操作：{v.log_type||''}</span>
                                                    <span style={{display:'block'}}>内容：{v.mark||'无内容'}</span>
                                                </div>
                                            )
                                        }
                                    </div>
                                    <Question data={question} num={1}/>
                                </div>
                            </Card>

                        }
                    </div>
                </div>
            </div>
        );
    }

}

const mapStateTopProps = (state) => {
    const errorDuty = state.questionBox.errorDuty;
    return {

    };
}
const mapDispatchToProps = dispatch => {
    return ({

    });
};
export default connect(mapStateTopProps,mapDispatchToProps)(ErrorDuty)


// WEBPACK FOOTER //
// ./src/entry_app/question_manage/question_explain/error_duty/view.js